<template>
  <div class="img-box">
    <span class="img-detail" v-for="(item,index) in imgList" :key="index">
        <img :src="item.src2" :class="item.class" v-show="activeBank!==item.id">
        <img :src="item.src1" :class="item.class" v-show="activeBank===item.id">
    </span>
  </div>
</template>

<script>
  export default {
    name: "partnerImg",
    data() {
      return {
        activeBank: "0",
        imgList: [
          {
            id: "1",
            name: "浦发银行",
            class: "img-detail1",
            src1: require("../../assets/bank/bank8-1.png"),
            src2: require('../../assets/bank/bank8-2.png'),
          },
          // {
          //   id: "2",
          //   class: "img-detail2",
          //   name: "招商银行",
          //   src1: require("../../assets/bank/bank11-1.png"),
          //   src2: require('../../assets/bank/bank11-2.png'),
          // },
          {
            id: "3",
            name: "华夏银行",
            class: "img-detail3",
            src1: require("../../assets/bank/bank4-1.png"),
            src2: require('../../assets/bank/bank4-2.png'),
          },
          {
            id: "4",
            name: "交通银行",
            class: "img-detail4",
            src1: require("../../assets/bank/bank6-1.png"),
            src2: require('../../assets/bank/bank6-2.png'),
          },
          {
            id: "5",
            name: "民生银行",
            class: "img-detail5",
            src1: require("../../assets/bank/bank7-1.png"),
            src2: require('../../assets/bank/bank7-2.png'),
          },
          {
            id: "6",
            name: "广州银行",
            class: "img-detail6",
            src1: require("../../assets/bank/bank2-1.png"),
            src2: require('../../assets/bank/bank2-2.png'),
          },
          {
            id: "7",
            name: "兴业银行",
            class: "img-detail7",
            src1: require("../../assets/bank/bank10-1.png"),
            src2: require('../../assets/bank/bank10-2.png'),
          },
          {
            id: "8",
            name: "光大银行",
            class: "img-detail8",
            src1: require("../../assets/bank/bank1-1.png"),
            src2: require('../../assets/bank/bank1-2.png'),
          },
          {
            id: "9",
            name: "中信银行",
            class: "img-detail9",
            src1: require("../../assets/bank/bank12-1.png"),
            src2: require('../../assets/bank/bank12-2.png'),
          },
          {
            id: "10",
            name: "建设银行",
            class: "img-detail10",
            src1: require("../../assets/bank/bank5-1.png"),
            src2: require('../../assets/bank/bank5-2.png'),
          },
          {
            id: "11",
            name: "天津银行",
            class: "img-detail11",
            src1: require("../../assets/bank/bank9-1.png"),
            src2: require('../../assets/bank/bank9-2.png'),
          },
          {
            id: "12",
            name: "渤海银行",
            class: "img-detail12",
            src1: require('../../assets/bank/bank0-1.png'),
            src2: require('../../assets/bank/bank0-2.png'),
          },
          {
            id: "13",
            name: "哈尔斌银行",
            class: "img-detail13",
            src1: require("../../assets/bank/bank3-1.png"),
            src2: require('../../assets/bank/bank3-2.png'),
          }
        ],
      }
    },
    methods: {
      hoverEvents() {
        for (let i = 1; i < 14; i++) {
          let targets = document.querySelector(".img-detail" + i);
          targets.addEventListener("mouseover", () => {
            this.activeBank = i.toString();
          })
        }
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.hoverEvents();
      });
    }
  }
</script>

<style scoped>
  .img-box {
    width: 90%;
    display: flex;
    flex-flow: row wrap;
    justify-content: flex-start;
    text-align: left;
    margin-top: 50px;
    margin-left: 50%;
    -webkit-transform: translateX(-50%);
    -moz-transform: translateX(-50%);
    -ms-transform: translateX(-50%);
    -o-transform: translateX(-50%);
    transform: translateX(-50%);
    overflow: hidden;
  }

  .img-detail {
    width: 16%;
    margin-right: 5%;
  }
  .img-detail:nth-of-type(5n){
    margin-right: 0;
  }


  .img-detail img {
    display: inline-block;
    width: 100%;
    margin: 0 auto;
  }

  /*  .img-detail img:hover {
      opacity: 1;
    }*/
</style>



// WEBPACK FOOTER //
// src/views/components/partnerImg.vue